module.exports = __webpack_public_path__ + "img/grupo-her-car.eb3b18f2.png";